import { Action as HistoryAction } from 'rete-history-plugin';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import withRerender from '~lib/common/hoc/withRerender';

let isTrackingEnabled = false;

export function enableHistoryTracking(value) {
  isTrackingEnabled = value;
}

function trackNodeHistory(nodeComponent, node, emitter) {
  nodeComponent.data.component = withRerender()(nodeComponent.data.component);
  node.currentData = cloneDeep(node.data);

  const populateHistory = debounce(nodeOrControl => {
    if (!isTrackingEnabled) {
      return;
    }
    if (nodeOrControl !== node && nodeOrControl.parent !== node) {
      return;
    }

    const oldData = node.currentData;
    const newData = node.data;
    if (isNewComment(oldData, newData)) {
      processNewComment(node, newData);
    }
    else if (!isEqual(oldData, newData)) {
      emitter.trigger(
        'addhistory',
        new NodeChangeAction(
          nodeComponent,
          node,
          oldData,
          newData,
        ),
      );
    }

  }, 100);
  emitter.on('process', populateHistory);
}

function isNewComment(oldData, newData) {
  return (!oldData.hasOwnProperty('comment') && newData.hasOwnProperty('comment'));
}

function processNewComment(node, newData) {
  // Need to track the data of a new comment, but don't add it to the change history
  // since rete handles new nodes
  node.currentData = newData;
}

class NodeChangeAction extends HistoryAction {
  constructor(nodeComponent, node, oldData, newData) {
    super();
    // console.log('NodeChangeAction::ctor')
    this.nodeComponent = nodeComponent;
    this.node = node;
    this.oldData = cloneDeep(oldData);
    this.newData = cloneDeep(newData);
    node.currentData = this.newData;
  }

  undo() {
    // console.log('NodeChangeAction::undo')
    this.node.data = cloneDeep(this.oldData);
    this.node.currentData = this.oldData;
    this.node.vueContext.rerender();
  }

  redo() {
    // console.log('NodeChangeAction::redo')
    this.node.data = cloneDeep(this.newData);
    this.node.currentData = this.newData;
    this.node.vueContext.rerender();
  }
}

export default trackNodeHistory;
